<div class="container">

  <!-- VISTA FORMULARIO -->
  <ng-container *ngIf="mode === 'form'; else postFormView">

    <!-- Información de pago -->
    <div class="card">
      <app-agricola-stepper
        [steps]="steps"
        [currentStep]="selectedIndex"
        (backClick)="previousStep.emit()"
        (stepClick)="goToStep($event)">
      </app-agricola-stepper>

      <h2 class="title-center">Información de pago</h2>
      <p class="subtitle-center">Ingresa algunos datos de forma manual</p>

      <div class="insured-block">
        <div class="insured-info">
          <div class="label">Asegurado/ Tomador</div>
          <div class="value client-summary">
            <span class="client-summary-item">
              <span class="client-summary-label">Nombre de cliente:</span>
              <span class="client-summary-value">{{ insuredDisplayName }}</span>
            </span>
            <span class="client-summary-item" *ngIf="documentNumber">
              <span class="client-summary-label">Número único:</span>
              <span class="client-summary-value">{{ documentNumber }}</span>
            </span>
          </div>
        </div>

        <div class="account-selector" *ngIf="hasMultipleAccounts">
          <app-sis-select
            label="*Cuenta a utilizar"
            caption="El cliente tiene varias cuentas. Selecciona la que se usará para el cobro."
            [options]="accountOptions"
            [ngModel]="selectedAccountKey"
            (ngModelChange)="onAccountSelected($event)"
            [loading]="loadingAccounts"
            [loadedKey]="accountsLoadedKey">
          </app-sis-select>
        </div>

        <div class="grid-4" [formGroup]="paymentInfo">
          <!-- "Datos bancarios" no se muestra: la cuenta se elige arriba y sus
               datos ya se despliegan en los campos siguientes. -->

          <div class="field" [ngClass]="{'invalid': accountType?.invalid && accountType?.touched}">
            <app-sis-field
              label="*Tipo de cuenta"
              [readonly]="true"
              [displayValue]="accountTypeDisplay"
              [loading]="loadingAccounts"
              [loadedKey]="accountsLoadedKey"
              loadedMessage="Información de cuentas cargada"
              [loadFailed]="accountsLoadFailed"
              [helper]="accountsLoadFailedText"
              (retryLoad)="retryLoadAccounts()"
              [error]="accountType?.invalid && accountType?.touched ? 'Ingresa tipo de cuenta' : ''"
              formControlName="accountType">
            </app-sis-field>
          </div>

          <div class="field" [ngClass]="{'invalid': accountNumber?.invalid && accountNumber?.touched}">
            <app-sis-field
              [label]="accountNumberLabel"
              [readonly]="true"
              [displayValue]="accountNumberDisplay"
              [loading]="loadingAccounts"
              [loadedKey]="accountsLoadedKey"
              loadedMessage="Información de cuentas cargada"
              [loadFailed]="accountsLoadFailed"
              [helper]="accountsLoadFailedText"
              (retryLoad)="retryLoadAccounts()"
              [error]="accountNumber?.invalid && accountNumber?.touched ? 'Ingresa número de cuenta' : ''"
              formControlName="accountNumber">
            </app-sis-field>
          </div>

          <div class="field" [ngClass]="{'invalid': accountName?.invalid && accountName?.touched}">
            <app-sis-field
              label="*Nombre de cuenta"
              [readonly]="true"
              [loading]="loadingAccounts"
              [loadedKey]="accountsLoadedKey"
              loadedMessage="Información de cuentas cargada"
              [loadFailed]="accountsLoadFailed"
              [helper]="accountsLoadFailedText"
              (retryLoad)="retryLoadAccounts()"
              [error]="accountName?.invalid && accountName?.touched ? 'Ingresa nombre de la cuenta' : ''"
              formControlName="accountName">
            </app-sis-field>
          </div>

          <div class="field" [ngClass]="{'invalid': accountStatus?.invalid && accountStatus?.touched}">
            <app-sis-field
              label="*Estado de cuenta"
              [readonly]="true"
              [loading]="loadingAccounts"
              [loadedKey]="accountsLoadedKey"
              loadedMessage="Información de cuentas cargada"
              [loadFailed]="accountsLoadFailed"
              [helper]="accountsLoadFailedText"
              (retryLoad)="retryLoadAccounts()"
              [error]="accountStatus?.invalid && accountStatus?.touched ? 'Ingresa estado de la cuenta' : ''"
              formControlName="accountStatus">
            </app-sis-field>
          </div>

        </div>

        <div class="checkbox-row" [formGroup]="paymentInfo">
          <app-sis-checkbox formControlName="autoDebitAuthorized">
            Autorizo el débito mensual del cobro a mi cuenta
          </app-sis-checkbox>
        </div>

        <div class="checkbox-row" [formGroup]="paymentInfo">
          <app-sis-checkbox formControlName="acceptsMulticharge">
            Cliente autoriza a debitar el monto correspondiente de cualquiera de sus cuentas de ahorro o corrientes
            registradas, en caso de que la cuenta inicialmente indicada no disponga de fondos suficientes
          </app-sis-checkbox>
        </div>
      </div>
    </div>

    <!-- Información del vendedor -->
    <div class="card">
      <h2 class="title-center">Información del vendedor</h2>
      <p class="subtitle-center">Ingrese los datos del vendedor</p>

      <div class="insured-block">
        <div class="grid-4" [formGroup]="sellerInfo">
          <div class="field" [ngClass]="{'invalid': sellerType?.invalid && sellerType?.touched}">
            <app-sis-select
              label="*Tipo de vendedor"
              placeholder="Selecciona el tipo"
              [options]="sellerTypeOptions"
              [error]="sellerType?.invalid && sellerType?.touched ? 'Selecciona tipo de vendedor' : ''"
              formControlName="sellerType">
            </app-sis-select>
          </div>

          <div class="field" [ngClass]="{'invalid': sellerCode?.invalid && sellerCode?.touched}">
            <app-sis-field
              label="*Código de vendedor"
              [maxlength]="6"
              [error]="sellerCode?.touched && sellerCode?.hasError('invalidSellerCode') ? 'Código inválido: ingresa solo números.' : (sellerCode?.invalid && sellerCode?.touched ? 'Ingresa código de vendedor' : '')"
              formControlName="sellerCode">
            </app-sis-field>
          </div>

          <div class="field" [ngClass]="{'invalid': sellerName?.invalid && sellerName?.touched}">
            <app-sis-field
              label="*Nombre del vendedor"
              [readonly]="true"
              [helper]="validatingSellerCode ? 'Validando código de vendedor...' : (sellerNameLoadFailed ? 'No se pudo validar el vendedor' : '')"
              [loadFailed]="sellerNameLoadFailed"
              (retryLoad)="retrySellerNameLookup()"
              [error]="sellerName?.invalid && sellerName?.touched ? 'Ingresa nombre del vendedor' : ''"
              formControlName="sellerName">
            </app-sis-field>
          </div>

          <div class="field" [ngClass]="{'invalid': agencyCode?.invalid && agencyCode?.touched}">
            <app-sis-select
              label="*Agencia"
              placeholder="Selecciona la agencia"
              [options]="agencyOptions"
              [loading]="loadingAgencies"
              [error]="agencyCode?.invalid && agencyCode?.touched ? 'Selecciona una agencia' : ''"
              formControlName="agencyCode">
            </app-sis-select>
          </div>
        </div>
      </div>
    </div>

    <!-- Firma digital de asistencia -->
    <div class="card" *ngIf="assistanceRequiresDigitalSignature">
      <h2 class="title-center">Proceso de Firma</h2>
      <p class="subtitle-center">
        {{ showDigitalSignatureOption ? 'Selecciona cómo completar la firma de la asistencia' : 'Completa la firma física de la asistencia' }}
      </p>

      <div class="insured-block">
        <app-sis-radio-group
          *ngIf="showDigitalSignatureOption"
          legend="Modalidad de firma"
          [options]="assistanceSignatureFlowOptions"
          [ngModel]="assistanceSignatureFlow"
          (ngModelChange)="onAssistanceSignatureFlowChange($event)">
        </app-sis-radio-group>

        <div class="private-link-panel" *ngIf="usesAssistancePrivateLink">
          <p class="private-link-copy" *ngIf="usesSellerValidatedSignature; else clientEmitsCopy">
            El cliente recibirá un enlace para revisar la información y firmar. Aquí verás su firma para validarla y emitir tú la asistencia.
          </p>
          <ng-template #clientEmitsCopy>
            <p class="private-link-copy">
              El cliente recibirá un enlace para revisar la información, firmar y emitir la asistencia. El vendedor esperará aquí hasta que se confirme la validación.
            </p>
          </ng-template>

          <div class="contact-summary">
            <div><strong>Correo:</strong> {{ voucherEmail || 'Sin correo registrado' }}</div>
            <div><strong>Teléfono:</strong> {{ customerPhoneForLink || 'Sin teléfono registrado' }}</div>
          </div>

          <div class="banner error" role="alert" *ngIf="privateLinkSetupError">
            <div class="icon" aria-hidden="true">!</div>
            <div class="text">
              <h4>{{ privateLinkSetupError }}</h4>
            </div>
          </div>

          <div class="actions-row">
            <app-sis-button variant="secondary" (pressed)="onCancel()">Cancelar</app-sis-button>
            <app-sis-button
              [disabled]="sendingPrivateLink || loadingAccounts || !!privateLinkSetupError"
              (pressed)="sendPrivateLinkByEmail()">
              {{ sendingPrivateLink ? 'Enviando...' : 'Enviar enlace por correo' }}
            </app-sis-button>
            <app-sis-button
              variant="secondary"
              [disabled]="sendingPrivateLink || loadingAccounts || !!privateLinkSetupError"
              (pressed)="sendPrivateLinkBySms()">
              Enviar enlace por SMS
            </app-sis-button>
          </div>
        </div>

        <div class="doc-signature" *ngIf="usesAssistanceContingency">
          <!-- Botón "Descargar plantilla" oculto: la plantilla se entrega por
               fuera del wizard. La lógica (downloadContingencyTemplate) se
               conserva por si se vuelve a habilitar. -->

          <label
            class="doc-upload-dropzone"
            [class.dragging]="isDraggingContingencyFile"
            [class.has-file]="!!contingencyFileName"
            (dragover)="onContingencyDragOver($event)"
            (dragleave)="onContingencyDragLeave($event)"
            (drop)="onContingencyDrop($event)">
            <span class="doc-upload-icon" aria-hidden="true">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="17 8 12 3 7 8"/>
                <line x1="12" y1="3" x2="12" y2="15"/>
              </svg>
            </span>
            <span class="doc-upload-text">
              <strong>{{ contingencyFileName || 'Arrastra el PDF de contingencia aquí' }}</strong>
              <span *ngIf="!contingencyFileName">o haz clic para buscar el archivo</span>
            </span>
            <span class="doc-upload-browse">Examinar</span>
            <input type="file" accept="application/pdf" (change)="onSelectContingencyPdf($event)" />
          </label>
        </div>
      </div>
    </div>

    <!-- Botones inferiores -->
    <div class="actions-row" *ngIf="!usesAssistancePrivateLink">
      <app-sis-button variant="secondary" (pressed)="onCancel()">Cancelar</app-sis-button>
      <app-sis-button [disabled]="submitting || loadingAccounts" (pressed)="onSubmit()">
        {{ loadingAccounts ? 'Cargando cuentas...' : (submitting ? (isTmk ? 'Generando...' : 'Expidiendo...') : (isTmk ? 'Generar número de proceso' : 'Expedir')) }}
      </app-sis-button>
    </div>
  </ng-container>

  <ng-template #postFormView>
    <ng-container *ngIf="mode === 'assistanceWaiting'">
      <div class="card">
        <div class="waiting-card">
          <div class="waiting-spinner" aria-hidden="true"></div>
          <h2 class="title-center">Esperando firma del cliente</h2>
          <p class="subtitle-center">{{ assistanceWaitMessage }}</p>

          <div class="waiting-details">
            <div><strong>Correo:</strong> {{ voucherEmail || 'Sin correo registrado' }}</div>
            <div><strong>Teléfono:</strong> {{ customerPhoneForLink || 'Sin teléfono registrado' }}</div>
            <div><strong>Token:</strong> {{ assistanceToken || 'Pendiente' }}</div>
            <div><strong>Emission log:</strong> {{ assistanceEmissionLogId || 'Pendiente' }}</div>
          </div>

          <div class="actions-row">
            <app-sis-button
              [disabled]="sendingPrivateLink || resendCooldown > 0"
              (pressed)="sendPrivateLinkByEmail()">
              {{ resendCooldown > 0 ? ('Reenviar correo en ' + resendCooldown + 's') : 'Reenviar por correo' }}
            </app-sis-button>
            <app-sis-button
              variant="secondary"
              [disabled]="sendingPrivateLink || resendCooldown > 0"
              (pressed)="sendPrivateLinkBySms()">
              {{ resendCooldown > 0 ? ('Reenviar SMS en ' + resendCooldown + 's') : 'Reenviar por SMS' }}
            </app-sis-button>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Revisión de firma (validate_signature_by_seller): el cliente firmó y el
         vendedor valida antes de emitir -->
    <ng-container *ngIf="mode === 'assistanceSignatureReview'">
      <div class="card">
        <h2 class="title-center">Validar firma del cliente</h2>
        <p class="subtitle-center">Revisa la firma capturada por el cliente. Si es correcta, emite la asistencia.</p>

        <div class="signature-review">
          <div class="signature-review-meta">
            <div><strong>Cliente:</strong> {{ signerName || insuredDisplayName }}</div>
            <div *ngIf="signedAt"><strong>Firmado:</strong> {{ signedAt }}</div>
          </div>

          <div class="signature-preview">
            <div class="waiting-spinner" aria-hidden="true" *ngIf="signatureLoading"></div>
            <img
              *ngIf="!signatureLoading && signaturePreviewUrl"
              [src]="signaturePreviewUrl"
              alt="Firma del cliente" />
            <p class="document-error" *ngIf="signatureReviewError">{{ signatureReviewError }}</p>
            <app-sis-button
              *ngIf="!signatureLoading && !signaturePreviewUrl"
              variant="secondary"
              (pressed)="retryLoadSignaturePreview()">
              Reintentar carga de la firma
            </app-sis-button>
          </div>
        </div>

        <!-- Feature 1: evidencia de la firma (client_sign_emission_log) -->
        <div class="signature-audit">
          <h3 class="signature-audit-title">Información de la firma</h3>
          <div class="waiting-spinner" aria-hidden="true" *ngIf="signEmissionLogLoading"></div>
          <dl class="signature-audit-list" *ngIf="!signEmissionLogLoading && signEmissionLogEntries.length">
            <ng-container *ngFor="let entry of signEmissionLogEntries">
              <dt>{{ entry.label }}</dt>
              <dd>{{ entry.value }}</dd>
            </ng-container>
          </dl>
          <p class="document-error" *ngIf="signEmissionLogError">{{ signEmissionLogError }}</p>
          <app-sis-button
            *ngIf="!signEmissionLogLoading && signEmissionLogError"
            variant="secondary"
            (pressed)="retryLoadSignEmissionLog()">
            Reintentar
          </app-sis-button>
        </div>

        <div class="actions-row">
          <app-sis-button
            variant="secondary"
            [disabled]="finalizingPrivateLink"
            (pressed)="rejectSignature()">
            Rechazar firma
          </app-sis-button>
          <app-sis-button
            [disabled]="finalizingPrivateLink || signatureLoading || !signaturePreviewUrl"
            (pressed)="validateAndEmit()">
            {{ finalizingPrivateLink ? 'Emitiendo...' : 'Validar y emitir' }}
          </app-sis-button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="mode !== 'assistanceWaiting' && mode !== 'assistanceSignatureReview'">
      <ng-container *ngTemplateOutlet="summaryView"></ng-container>
    </ng-container>
  </ng-template>

  <!-- VISTA RESUMEN / POLIZA CREADA -->
  <ng-template #summaryView>
    <div class="card">

      <app-agricola-stepper
        [steps]="steps"
        [currentStep]="selectedIndex"
        (backClick)="returnToSearch.emit()"
        (stepClick)="goToStep($event)">
      </app-agricola-stepper>

      <div class="summary-card">
        <div class="summary-title">{{ mode === 'successTmk' ? 'No de Proceso' : 'No de Póliza' }}</div>
        <div class="summary-number">{{ mode === 'successTmk' ? tmkProcessNumber : policyNumber }}</div>
        <div class="summary-name">{{ insuredName }}</div>
        <div class="summary-validity" *ngIf="mode !== 'successTmk'">
          Validez desde: {{ validityFrom }}
        </div>
        <div class="summary-validity" *ngIf="mode === 'successTmk'">
          Venta registrada para emisión por telemarketing. Dicta este número al
          cliente; la póliza se emite al confirmar la llamada.
        </div>
      </div>

      <div class="document-error-box" *ngIf="documentError && mode !== 'successTmk'">
        <p class="document-error">{{ documentError }}</p>
        <app-sis-button
          variant="secondary"
          [disabled]="policyDocumentBusy"
          (pressed)="viewPolicyDocument()">
          <span class="document-button-content">
            <span class="button-spinner" *ngIf="policyDocumentBusy" aria-hidden="true"></span>
            {{ policyDocumentBusy ? 'REINTENTANDO…' : 'REINTENTAR' }}
          </span>
        </app-sis-button>
      </div>

      <div class="actions-row center">
        <app-sis-button
          *ngIf="showPolicyDocumentButton && mode !== 'successTmk'"
          variant="secondary"
          [disabled]="policyDocumentBusy"
          (pressed)="viewPolicyDocument()">
          <span class="document-button-content">
            <span class="button-spinner" *ngIf="policyDocumentBusy" aria-hidden="true"></span>
            {{ policyDocumentButtonLabel }}
          </span>
        </app-sis-button>
        <app-sis-button (pressed)="returnHome.emit()">
          REGRESAR A INICIO
        </app-sis-button>
      </div>
    </div>
  </ng-template>

</div>
